module.exports = __webpack_public_path__ + "img/seo-content-collapsible-cjdr.bd8de42d.png";